export const getValues = formValues => {
return {
    type: 'REGISTRATION',
    payload: formValues
 }
}